module.exports = __webpack_public_path__ + "img/education3.92f9e357.jpeg";